module.exports = __webpack_public_path__ + "images/sns_campaign_lp/mainvisual-present-1-pc_59b27332fd6ed591bba474912f4608d7.png";